
import Vue from "vue";
import AuthBasic from "../../data/authBasic";
import { UI_ENDPOINT } from "../../constants/EndPoints";
import axios from "axios";

export default Vue.extend({
  name: "enterprise-footer",
  data() {
    return {
      governorName: ""
    }
  },
  created() {
    let url = UI_ENDPOINT.GET_GOVERNOR_NAME;
    axios
      .get(url, { auth: AuthBasic })
      .then(response => {
        this.governorName = response.data;
      })
      .catch(error => {
        this.governorName = error.response.status + ": " + error.response.statusText;
      })
  }
});
